import React from "react";
import ActiveSessions from "./activesessions.svg";

function ActiveSessionsIcon() {
  return <img src={ActiveSessions} alt="ActiveSessions Icon" />;
}

export default ActiveSessionsIcon;
